import clsx from "clsx";
import { FlagUkraine } from "./flag-ukraine";

export const tag = {
	LOCATION({ offer }) {
		return (
			<div className="steam-job__tag LOCATION">
				<svg width={24} viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
					<path d="M12.5 12C13.05 12 13.5208 11.8042 13.9125 11.4125C14.3042 11.0208 14.5 10.55 14.5 10C14.5 9.45 14.3042 8.97917 13.9125 8.5875C13.5208 8.19583 13.05 8 12.5 8C11.95 8 11.4792 8.19583 11.0875 8.5875C10.6958 8.97917 10.5 9.45 10.5 10C10.5 10.55 10.6958 11.0208 11.0875 11.4125C11.4792 11.8042 11.95 12 12.5 12ZM12.5 19.35C14.5333 17.4833 16.0417 15.7875 17.025 14.2625C18.0083 12.7375 18.5 11.3833 18.5 10.2C18.5 8.38333 17.9208 6.89583 16.7625 5.7375C15.6042 4.57917 14.1833 4 12.5 4C10.8167 4 9.39583 4.57917 8.2375 5.7375C7.07917 6.89583 6.5 8.38333 6.5 10.2C6.5 11.3833 6.99167 12.7375 7.975 14.2625C8.95833 15.7875 10.4667 17.4833 12.5 19.35ZM12.5 22C9.81667 19.7167 7.8125 17.5958 6.4875 15.6375C5.1625 13.6792 4.5 11.8667 4.5 10.2C4.5 7.7 5.30417 5.70833 6.9125 4.225C8.52083 2.74167 10.3833 2 12.5 2C14.6167 2 16.4792 2.74167 18.0875 4.225C19.6958 5.70833 20.5 7.7 20.5 10.2C20.5 11.8667 19.8375 13.6792 18.5125 15.6375C17.1875 17.5958 15.1833 19.7167 12.5 22Z" />
				</svg>

				<div>
					<span>{offer.city}</span>

					<svg width={1} viewBox="0 0 1 24" xmlns="http://www.w3.org/2000/svg">
						<rect width="1" height="24" fill="#565555" />
					</svg>

					<span>{offer.province}</span>
				</div>
			</div>
		);
	},

	CONTRACT({ offer }) {
		return (
			<div className="steam-job__tag CONTRACT">
				<svg width={24} viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
					<path d="M4.5 21C3.95 21 3.47917 20.8042 3.0875 20.4125C2.69583 20.0208 2.5 19.55 2.5 19V8C2.5 7.45 2.69583 6.97917 3.0875 6.5875C3.47917 6.19583 3.95 6 4.5 6H8.5V4C8.5 3.45 8.69583 2.97917 9.0875 2.5875C9.47917 2.19583 9.95 2 10.5 2H14.5C15.05 2 15.5208 2.19583 15.9125 2.5875C16.3042 2.97917 16.5 3.45 16.5 4V6H20.5C21.05 6 21.5208 6.19583 21.9125 6.5875C22.3042 6.97917 22.5 7.45 22.5 8V19C22.5 19.55 22.3042 20.0208 21.9125 20.4125C21.5208 20.8042 21.05 21 20.5 21H4.5ZM4.5 19H20.5V8H4.5V19ZM10.5 6H14.5V4H10.5V6Z" />
				</svg>

				<div>
					<span>Praca stała</span>

					<span>UoP</span>
				</div>
			</div>
		);
	},

	UKRAINE({ offer }) {
		return (
			<div className="steam-job__tag UKRAINE">
				<FlagUkraine />

				<span>також для українців</span>
			</div>
		);
	},

	SALARY({ offer }) {
		return (
			<div className="steam-job__tag SALARY">
				<svg width={24} viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
					<path d="M5 21C4.45 21 3.97917 20.8042 3.5875 20.4125C3.19583 20.0208 3 19.55 3 19V5C3 4.45 3.19583 3.97917 3.5875 3.5875C3.97917 3.19583 4.45 3 5 3H19C19.55 3 20.0208 3.19583 20.4125 3.5875C20.8042 3.97917 21 4.45 21 5V7.5H19V5H5V19H19V16.5H21V19C21 19.55 20.8042 20.0208 20.4125 20.4125C20.0208 20.8042 19.55 21 19 21H5ZM13 17C12.45 17 11.9792 16.8042 11.5875 16.4125C11.1958 16.0208 11 15.55 11 15V9C11 8.45 11.1958 7.97917 11.5875 7.5875C11.9792 7.19583 12.45 7 13 7H20C20.55 7 21.0208 7.19583 21.4125 7.5875C21.8042 7.97917 22 8.45 22 9V15C22 15.55 21.8042 16.0208 21.4125 16.4125C21.0208 16.8042 20.55 17 20 17H13ZM20 15V9H13V15H20ZM16 13.5C16.4167 13.5 16.7708 13.3542 17.0625 13.0625C17.3542 12.7708 17.5 12.4167 17.5 12C17.5 11.5833 17.3542 11.2292 17.0625 10.9375C16.7708 10.6458 16.4167 10.5 16 10.5C15.5833 10.5 15.2292 10.6458 14.9375 10.9375C14.6458 11.2292 14.5 11.5833 14.5 12C14.5 12.4167 14.6458 12.7708 14.9375 13.0625C15.2292 13.3542 15.5833 13.5 16 13.5Z" />
				</svg>

				<span>{offer.salary_to} brutto/h</span>
			</div>
		);
	},

	FAVORITE({ offer, favorite, toggle }) {
		return (
			<button
				className={clsx("steam-job__tag FAVORITE", favorite && "is-saved")}
				onClick={toggle}
				aria-label="save to favorites"
			>
				<svg width={24} viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
					<path d="M21 9.5L12.5 19.5L4 12.5L3 6.5L7.5 3.5L12 5.5L16 3.5L20 5L21 9.5Z" />

					<path d="M12 21.0004L10.55 19.7004C8.86667 18.1837 7.475 16.8754 6.375 15.7754C5.275 14.6754 4.4 13.6879 3.75 12.8129C3.1 11.9379 2.64583 11.1337 2.3875 10.4004C2.12917 9.66706 2 8.91706 2 8.15039C2 6.58372 2.525 5.27539 3.575 4.22539C4.625 3.17539 5.93333 2.65039 7.5 2.65039C8.36667 2.65039 9.19167 2.83372 9.975 3.20039C10.7583 3.56706 11.4333 4.08372 12 4.75039C12.5667 4.08372 13.2417 3.56706 14.025 3.20039C14.8083 2.83372 15.6333 2.65039 16.5 2.65039C18.0667 2.65039 19.375 3.17539 20.425 4.22539C21.475 5.27539 22 6.58372 22 8.15039C22 8.91706 21.8708 9.66706 21.6125 10.4004C21.3542 11.1337 20.9 11.9379 20.25 12.8129C19.6 13.6879 18.725 14.6754 17.625 15.7754C16.525 16.8754 15.1333 18.1837 13.45 19.7004L12 21.0004ZM12 18.3004C13.6 16.8671 14.9167 15.6379 15.95 14.6129C16.9833 13.5879 17.8 12.6962 18.4 11.9379C19 11.1796 19.4167 10.5046 19.65 9.91289C19.8833 9.32122 20 8.73372 20 8.15039C20 7.15039 19.6667 6.31706 19 5.65039C18.3333 4.98372 17.5 4.65039 16.5 4.65039C15.7167 4.65039 14.9917 4.87122 14.325 5.31289C13.6583 5.75456 13.2 6.31706 12.95 7.00039H11.05C10.8 6.31706 10.3417 5.75456 9.675 5.31289C9.00833 4.87122 8.28333 4.65039 7.5 4.65039C6.5 4.65039 5.66667 4.98372 5 5.65039C4.33333 6.31706 4 7.15039 4 8.15039C4 8.73372 4.11667 9.32122 4.35 9.91289C4.58333 10.5046 5 11.1796 5.6 11.9379C6.2 12.6962 7.01667 13.5879 8.05 14.6129C9.08333 15.6379 10.4 16.8671 12 18.3004Z" />
				</svg>
			</button>
		);
	},
};
